export default "__VITE_ASSET__Cc1IMh2e__"